import { Button, ButtonPropsColorOverrides, Tooltip, useTheme } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';

export interface MapStateButtonProps {
  tooltip: string;
  color: OverridableStringUnion<
    'primary' | 'warning' | 'error' | 'inherit',
    ButtonPropsColorOverrides
  >;
  filled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

export function MapStateButton({ tooltip, color, filled, onClick, children }: MapStateButtonProps) {
  const theme = useTheme();

  return (
    <Tooltip title={tooltip}>
      <Button
        sx={{
          padding: theme.spacing(0.25),
          minWidth: theme.spacing(3),
          width: theme.spacing(3),
          height: theme.spacing(3),
          borderRadius: theme.spacing(2),
          fontSize: 'small',
          lineHeight: 1,
        }}
        color={color}
        variant={filled ? 'contained' : 'outlined'}
        onClick={onClick}
      >
        {children}
      </Button>
    </Tooltip>
  );
}
